import { OEMType as OEMTypeEnum } from '@luna-protocol/core/src/types.ts';
import config from '@luna-protocol/core/src/utils/feature-flags.json';
import { getSerialNumberItemTitle } from '../components/AmendDetails/getProducts.tsx';
import { OrderSummary, SerialNumber } from '../types.ts';

export const buildProductList = (dataObj?: OrderSummary, OEMType?: string, base_type?: string) => {
  if (!dataObj) return [];

  const productArrays = dataObj.serial_numbers.map((product: SerialNumber, i) => {
    const itemEntry =
      i === 0
        ? [
            {
              title: 'Item',
              value: dataObj.item_name,
            },
          ]
        : [];

    const serialNumberEntry = {
      title: getSerialNumberItemTitle(product.serial_number_type, 'Number'),
      value: product.serial_number,
      type: product.serial_number_type + '_' + i,
    };

    const serialNumberAssetClassEntry = {
      title: getSerialNumberItemTitle(product.serial_number_type, 'Asset Class'),
      value: product.serial_number_asset_class,
      type: product.serial_number_type + '_' + i,
    };

    const collateralIdEntry = {
      title: 'Collateral ID',
      value: product.collateral_id,
      type: product.serial_number_type + '_' + i,
    };

    const priceEntry = {
      title: getSerialNumberItemTitle(product.serial_number_type, 'Price'),
      value: product.product_price?.toFixed(2),
      type: product.serial_number_type + '_' + i,
    };

    const yearEntry = {
      title: getSerialNumberItemTitle(product.serial_number_type, 'Year'),
      value: product.year,
      type: product.serial_number_type + '_' + i,
    };

    const conditionEntry = {
      title: getSerialNumberItemTitle(product.serial_number_type, 'Condition'),
      value: product.condition.charAt(0).toUpperCase() + product.condition.slice(1),
      type: product.serial_number_type + '_' + i,
    };

    const makeEntry = {
      title: getSerialNumberItemTitle(product.serial_number_type, 'Make'),
      value: product.make,
      type: product.serial_number_type + '_' + i,
    };

    const modelEntry = {
      title: getSerialNumberItemTitle(product.serial_number_type, 'Model'),
      value: product.model,
      type: product.serial_number_type + '_' + i,
    };

    const colorEntry = {
      title: getSerialNumberItemTitle(product.serial_number_type, 'Color'),
      value: product.color,
      type: product.serial_number_type + '_' + i,
    };

    const nadaTitle = getSerialNumberItemTitle(product.serial_number_type, 'NADA/MSRP Invoice');
    let nadaLabel = 'NADA';
    if (OEMType === OEMTypeEnum.Brunswick || (config.FF_OEMTemplatesEnabled && base_type === 'marine')) {
      if (product.condition?.toLocaleLowerCase() === 'new') {
        nadaLabel = 'Invoice';
      } else {
        nadaLabel = 'NADA';
      }
    }
    if (
      OEMType === OEMTypeEnum.KTM ||
      OEMType === OEMTypeEnum.EZGO ||
      (config.FF_OEMTemplatesEnabled && base_type === 'powersports')
    ) {
      if (product.condition?.toLocaleLowerCase() === 'new') {
        nadaLabel = 'MSRP';
      } else {
        nadaLabel = 'NADA';
      }
    }
    const nadaEntry = {
      label: nadaLabel,
      title: nadaTitle,
      value: product.seller_purchase_price?.toFixed(2),
      type: product.serial_number_type + '_' + i,
    };

    return [
      ...itemEntry,
      makeEntry,
      modelEntry,
      colorEntry,
      yearEntry,
      serialNumberEntry,
      serialNumberAssetClassEntry,
      priceEntry,
      conditionEntry,
      nadaEntry,
      collateralIdEntry,
    ];
  });

  return productArrays;
};
